import { FileAccessInformation } from '@amzn/coral_com-amazon-carrierlogisticswebserver-model';
import { BehaviorSubject, Subject, from } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import APIResponse from '../models/APIResponse';
import getTermManualService from '../services/downloadTermManual';
import { downloadFile } from '../utils/downloadFile';

interface DownloadTermManualPayload {
  termKey: string;
}

export type FetchTermManualAPIResponse = APIResponse<FileAccessInformation, any>;

export const downloadTermManualAction$ = new Subject<DownloadTermManualPayload>();
const downloadTermManualPayloadStore$ = new BehaviorSubject<DownloadTermManualPayload>({
  termKey:''
});

export const downloadTermManualStore$ = new BehaviorSubject<FetchTermManualAPIResponse>({});
downloadTermManualAction$.subscribe(downloadTermManualPayloadStore$);
downloadTermManualAction$.pipe(
  switchMap(({ termKey }) => getTermManualService({ termKey }).pipe(
    map(({fileAccessInformation}) => {
      fileAccessInformation.forEach((fileInformation) => {
        downloadFile(fileInformation?.s3presignedUrl);
      });
      return { response: fileAccessInformation };
    }),
    catchError(err => from([{
      error: err
    }]))
  ))
).subscribe(downloadTermManualStore$);

downloadTermManualStore$.subscribe(({error}) => {
  if (!error) {
    // eslint-disable-next-line no-useless-return
    return;
  }
  // TODO: implement notification for failed request
});